import "@babel/polyfill";

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import injectTapEventPlugin from 'react-tap-event-plugin'

import './index.css'
import '../node_modules/sweetalert/dist/sweetalert.css'
import Router from './router'
import store from './store'
import HttpsRedirect from 'react-https-redirect';

// Needed for onTouchTap
injectTapEventPlugin()

// App
ReactDOM.render(
  <Provider store={store}>
    <Router />
  </Provider>,
  document.getElementById('root'),
)


// export const STATE_NOT_STARTED = 0
// export const STATE_STARTED = 1
// export const STATE_FINISHED = 2
// export const STATE_ACCEPTED = 3
// export const STATE_LOCKED = 4
// export const STATE_EXPIRED = 5
// export const STATE_REJECT = 6
// export const STATE_DAILY_EXPIRED = 7
// export const STATE_MAX_LIMIT = 8



// WEBPACK FOOTER //
// ./src/index.js